import React, { FC, useEffect, useMemo, useRef } from 'react'
import Table from 'uiKit/table/Table'
import { fileTableTitles } from './config/configs'
import { FileTableRow } from './FileTableRow'
import * as S from '../SourcesTable/SourcesTable.style'
import { knowledgeFileService } from '../../../api/knowledgeFile'
import { alertError } from 'api'

interface SourcesTableProps {
  sources: any
  onDelete: (source: any) => void
  fetchTrainingFiles: () => void
  updateSource?: (source) => void
}

export const ColaSourcesTable: FC<SourcesTableProps> = ({ sources, onDelete, fetchTrainingFiles, updateSource }) => {
  const highlightRef = useRef<HTMLTableRowElement>(null)

  const sourcesTrained = useMemo(() => {
    return Array.isArray(sources) ? sources.filter(source => source.status === 'READY') : []
  }, [sources])

  const notTrainedSources = useMemo(() => {
    return Array.isArray(sources) ? sources.filter(source => source.status !== 'READY') : []
  }, [sources])

  const onTrain = () => {
    knowledgeFileService
      .trainFiles()
      .then(() => {
        if (fetchTrainingFiles) {
          fetchTrainingFiles()
        }
      })
      .catch(error => {
        alertError(error?.message || 'Error during training')
      })
  }

  useEffect(() => {
    if (highlightRef.current) {
      highlightRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [highlightRef.current])

  return (
    <div>
      {notTrainedSources.length > 0 && (
        <>
          <S.HeaderWrap>
            <S.Header>FAILED FILES</S.Header>
            <S.Button onClick={onTrain}>Start training</S.Button>
          </S.HeaderWrap>
          <Table titles={fileTableTitles}>
            {notTrainedSources.map((source, index) => (
              <FileTableRow
                key={source._id}
                sources={source}
                index={index}
                onDelete={onDelete}
                updateSource={updateSource}
                isDownloadEnabled={true}
                textNotEditable={true}
              />
            ))}
          </Table>
        </>
      )}
      {sourcesTrained.length > 0 && (
        <>
          <S.HeaderWrap>
            <S.Header>TRAINED</S.Header>
          </S.HeaderWrap>
          <Table titles={fileTableTitles}>
            {sourcesTrained.map((source, index) => (
              <FileTableRow
                key={source._id}
                sources={source}
                index={index}
                onDelete={onDelete}
                updateSource={updateSource}
                isDownloadEnabled={true}
                textNotEditable={true}
              />
            ))}
          </Table>
        </>
      )}
    </div>
  )
}
